export enum CommonRoutes {
  FORBIDDEN = '/conteudo-privado',
}
